const selectCitationText = function (event) {
    if (!document.body.createTextRange) {
        // non-IE implementation
        const range = document.createRange();
        const selection = window.getSelection();

        range.selectNodeContents(event.currentTarget);
        selection.removeAllRanges();
        selection.addRange(range);
    } else {
        const range = document.body.createTextRange();
        range.moveToElementText(event.currentTarget);
        range.select();
    }
};

document.addEventListener('DOMContentLoaded', function () {
    // listeners to select the text for a citation
    const defaultCitation = document.getElementById('defaultCitation');
    const visibleDoi = document.querySelectorAll("p[data-citation-component='visibleDoiCitation']");
    const apaCitations = document.querySelectorAll("div[data-citation-component='apa']");
    const mlaCitations = document.querySelectorAll("div[data-citation-component='mla']");
    const bibtexCitations = document.querySelectorAll("div[data-citation-component='bibtex']");
    const customCitations = document.querySelectorAll("p[data-citation-component='custom']");

    if (defaultCitation) {
        defaultCitation.addEventListener('click', selectCitationText);
    }

    // using forloop because IE does not support forEach on these objects
    for (let i = 0; i < visibleDoi.length; i++) {
        visibleDoi[i].addEventListener('click', selectCitationText);
    }

    for (let i = 0; i < apaCitations.length; i++) {
        apaCitations[i].addEventListener('click', selectCitationText);
    }

    for (let i = 0; i < mlaCitations.length; i++) {
        mlaCitations[i].addEventListener('click', selectCitationText);
    }

    for (let i = 0; i < bibtexCitations.length; i++) {
        bibtexCitations[i].addEventListener('click', selectCitationText);
    }

    for (let i = 0; i < customCitations.length; i++) {
        customCitations[i].addEventListener('click', selectCitationText);
    }
});
